import { render, staticRenderFns } from "./ContentFieldset.vue?vue&type=template&id=345c6ce6&scoped=true"
import script from "./ContentFieldset.vue?vue&type=script&lang=js"
export * from "./ContentFieldset.vue?vue&type=script&lang=js"
import style0 from "./ContentFieldset.vue?vue&type=style&index=0&id=345c6ce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345c6ce6",
  null
  
)

export default component.exports